<template>
  <div
    :class="$style.card"
    @click="(e) => $handleBlockLinkClick(e, cardLinkEl?.$el)"
  >
    <AspectRatio ratio="278x209">
      <BasePicture
        :src="`${data?.fields?.image?.fields?.file?.url}?q=70&w=278&h=209&fit=thumb`"
        alt=""
      />
    </AspectRatio>
    <header :class="$style.header">
      <NuxtLinkLocale
        ref="cardLink"
        :class="$style.headerLink"
        :to="
          data?.fields?.identifier
            ? `/formats?format=${data?.fields?.identifier}`
            : ''
        "
        target="_blank"
      >
        {{ data?.fields?.name }}
      </NuxtLinkLocale>
    </header>
  </div>
</template>

<script setup lang="ts">
import type { TypeFormatWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { $handleBlockLinkClick } = useNuxtApp()

const cardLinkEl = useTemplateRef<ComponentPublicInstance | null>('cardLink')

defineProps<{
  data: TypeFormatWithoutUnresolvableLinksResponse | undefined
}>()
</script>

<style lang="scss" module>
.card {
  cursor: pointer;
  background-color: var(--gray-1);
  border: 1px solid var(--gray-3);
  transition: cubic-bezier(0.16, 1, 0.29, 0.99) 0.2s;

  &:hover,
  &:focus {
    border: 1px solid var(--gray-5);
  }
}

.header {
  padding: 7px 10px;
  color: var(--purple);
  text-align: center;
  font-weight: bold;
}

.headerLink {
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
}
</style>
